<template>
  <div class="row">
    <div class="col">
      <div class="pb-1">Purchase option (for the first bill)</div>
      <div class="d-flex flex-row">
        <div class="form-check form-check-inline pr-15">
          <input
            class="form-check-input mr-2"
            id="purchaseSfsLx"
            type="radio"
            v-model="form.purchaseSfsLx"
            name="purchaseSfsLx"
            :value="true"
            :class="{
              'input--error': isSubmit && error.errorPurchaseSfsLx,
            }"
          />
          <label class="form-check-label" for="purchaseSfsLx"
            >Purchase SFS LX</label
          >
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input mr-2"
            id="notPurchaseSfsLx"
            type="radio"
            v-model="form.purchaseSfsLx"
            name="purchaseSfsLx"
            :value="false"
            :class="{
              'input--error': isSubmit && error.errorPurchaseSfsLx,
            }"
          />
          <label class="form-check-label" for="notPurchaseSfsLx"
            >Non-SFS & No Purchase</label
          >
        </div>
      </div>
      <div v-if="isSubmit && error.errorPurchaseSfsLx" class="text-error">
        {{ error.errorPurchaseSfsLx.message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PurchaseOption",
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
  font-size: 12px;
}
</style>
